module.exports = __webpack_public_path__ + "static/media/signature-hand.27067821.png";